import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubscribeComponent } from './subscribe.component';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
@NgModule({
  declarations: [SubscribeComponent],
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    ReactiveFormsModule,
    ToastModule
  ],
  providers: [MessageService],
  exports: [SubscribeComponent]
})
export class SubscribeModule {}
